module.exports = __webpack_public_path__ + "img/Indodigi-hero.730ff6bc.webp";